import { ProviderRoleEnums } from "@api/graphql/types-and-hooks";

export const getRoleLabelFromEnum = (key: ProviderRoleEnums | string): string => {
  switch (key) {
    case ProviderRoleEnums.Bcba:
      return "BCBA";
    case ProviderRoleEnums.Rbt:
      return "RBT";
    case ProviderRoleEnums.AssessmentBcba:
      return "Assessment BCBA";
    case ProviderRoleEnums.Admin:
      return "Admin";
    case ProviderRoleEnums.Intake:
      return "Intake";
    case ProviderRoleEnums.Psychologist:
      return "Psychologist";
    case ProviderRoleEnums.EvaluationPsychologist:
      return "Evaluation Psychologist";
    case "FRONTERA_INTERNAL":
      return "Frontera Internal";
    default:
      // Capitalize the entire string if not matched
      return (key as string).replace(/_/g, " ").toUpperCase();
  }
};

export const getRoleDescription = (key: ProviderRoleEnums): string => {
  switch (key) {
    case ProviderRoleEnums.Bcba:
      return "BCBAs can view assessment reports and templates for clients they are assigned to. They also have access to the video portal to review session footage submitted by RBTs for their clients.";
    case ProviderRoleEnums.Rbt:
      return "RBTs can record and upload session videos for their assigned clients. They can review their own uploads in the video portal but do not have access to assessments or other RBTs’ videos.";
    case ProviderRoleEnums.AssessmentBcba:
      return "Assessment BCBAs can view all assessments across the clinic and access assessment templates specific to their role. This role is focused on performing and managing all aspects of assessments.";
    case ProviderRoleEnums.Admin:
      return "Admins can access client and provider profiles, review assessments/diagnostics reports, and manage provider/client profiles. Admins also have access to the video portal, allowing them to review session footage across the organization.";
    case ProviderRoleEnums.Intake:
      return "Intake can onboard new clients, manage client records, and oversee provider assignments across the clinic. They do not have access to clinical tools or assessments.";
    case ProviderRoleEnums.Psychologist:
      return "Evaluation Psychologists have access to evaluations and diagnosis tools across their clients in the clinic, including the assessment template library filtered to their discipline.";
    case ProviderRoleEnums.EvaluationPsychologist:
      return "Psychologists have access to evaluations and diagnosis tools across all clients in the clinic, including the assessment template library filtered to their discipline.";

    default:
      // Capitalize the entire string if not matched
      return (key as string).replace(/_/g, " ").toUpperCase();
  }
};
